import { Component } from '@angular/core';

@Component({
  selector: 'app-template-eval',
  templateUrl: './template-eval.component.html',
  styleUrls: ['./template-eval.component.css']
})
export class TemplateEvalComponent {

}
